var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8735 1H4.127C2.205 1 1 2.1965 1 4.1265V5.2875C0.999503 5.4985 1.1705 5.67 1.3815 5.67H1.3825H1.387C1.5955 5.67 1.765 5.501 1.765 5.292V5.283V4.1265C1.765 2.605 2.605 1.765 4.1265 1.765H7.8735C9.4 1.765 10.235 2.605 10.235 4.1265V7.8765C10.235 9.398 9.395 10.2335 7.8735 10.2335H4.127C2.601 10.2335 1.7655 9.3935 1.7655 7.8765C1.7655 7.6655 1.594 7.494 1.383 7.494C1.1715 7.494 1.0005 7.6655 1.0005 7.8765C1 9.804 2.196 11 4.122 11H7.8735C9.804 11 11 9.804 11 7.878V4.128C11 2.1965 9.804 1 7.8735 1ZM5.99725 8.27295C5.79025 8.27295 5.62225 8.10495 5.62225 7.89795V5.68795C5.62225 5.48095 5.79025 5.31295 5.99725 5.31295C6.20425 5.31295 6.37225 5.48095 6.37225 5.68795V7.89795C6.37225 8.10495 6.20425 8.27295 5.99725 8.27295ZM5.9974 4.47705H6.0024C6.2094 4.47705 6.3774 4.30905 6.3774 4.10205C6.3774 3.89505 6.2094 3.72705 6.0024 3.72705C5.7954 3.72705 5.6249 3.89505 5.6249 4.10205C5.6249 4.30905 5.7904 4.47705 5.9974 4.47705Z",
    fill: "#05083F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSquare);
export default __webpack_public_path__ + "static/media/info-square.db4926a1.svg";
export { ForwardRef as ReactComponent };